import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function Login() {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const { ok, error } = await login(identifier, password);
    setLoading(false);
    if (ok) { toast.success("Bienvenue sur Forum CI"); nav(from, { replace: true }); }
    else toast.error(error || "Connexion impossible");
  };

  return (
    <div className="min-h-[80vh] px-4 py-8 max-w-md mx-auto">
      <div className="flex flex-col items-center mb-6">
        <div className="w-14 h-14 rounded-2xl bg-[#E65100] flex items-center justify-center mb-3">
          <span className="text-white font-extrabold text-2xl font-[Manrope]">F</span>
        </div>
        <h1 className="font-[Manrope] font-extrabold text-2xl">Connexion</h1>
        <p className="text-sm text-[#73706B] mt-1">Bon retour sur Forum CI</p>
      </div>
      <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
        <div>
          <Label>Email ou téléphone</Label>
          <Input
            data-testid="login-identifier"
            required
            className="h-12 rounded-xl mt-1"
            value={identifier}
            onChange={(e) => setIdentifier(e.target.value)}
            placeholder="votre@email.com ou +225…"
          />
        </div>
        <div>
          <Label>Mot de passe</Label>
          <Input
            data-testid="login-password"
            required
            type="password"
            className="h-12 rounded-xl mt-1"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
          />
        </div>
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full h-12 rounded-xl bg-[#E65100] hover:bg-[#C44100] text-white font-bold">
          {loading ? "Connexion…" : "Se connecter"}
        </Button>
      </form>
      <div className="flex justify-end mt-4 text-sm">
        <Link to="/inscription" data-testid="link-register" className="font-semibold text-[#E65100]">Créer un compte</Link>
      </div>
    </div>
  );
}
